import { ProductTileProduct } from '../ProductTile'
import { AD_CELL_WIDTH, AD_CELL_WIDTH_WIDE } from '../PromoTile/constants'
import { ProductGridComponent, ProductGridItem } from './types'

const promoTile = {
  component: ProductGridComponent.promoTile,
  id: ProductGridComponent.promoTile,
}

const featureEntryPointBanner = {
  component: ProductGridComponent.featureEntryPointBanner,
  id: ProductGridComponent.featureEntryPointBanner,
}

const inlineTickerMessages = {
  component: ProductGridComponent.inlineTickerMessages,
  id: ProductGridComponent.inlineTickerMessages,
}

export const formatGridLayout = ({
  products,
  promoTileLocation,
  featureEntryPointBannerLocation,
  inlineTickerMessagesLocation,
  currentTilesPerRow,
}: {
  products: ProductTileProduct[]
  promoTileLocation: number
  featureEntryPointBannerLocation?: number
  inlineTickerMessagesLocation?: number
  currentTilesPerRow: number
}) => {
  let modulesAdjustedPositionFactor = 0
  /* istanbul ignore next */
  const promoTileAdjustment =
    currentTilesPerRow === AD_CELL_WIDTH_WIDE
      ? AD_CELL_WIDTH_WIDE
      : AD_CELL_WIDTH

  if (!products || products.length === 0) {
    return []
  }

  if (
    !promoTileLocation &&
    featureEntryPointBannerLocation === undefined &&
    inlineTickerMessagesLocation === undefined
  ) {
    return products
  }

  return products.reduce(
    (
      acc: ProductGridItem[],
      product: ProductTileProduct | ProductGridItem,
      currentIndex: number,
    ) => {
      const items = [...acc]

      if (
        featureEntryPointBannerLocation !== undefined &&
        currentIndex === featureEntryPointBannerLocation
      ) {
        items.push(featureEntryPointBanner)
      }

      if (promoTileLocation && currentIndex === promoTileLocation) {
        items.push(promoTile)
        modulesAdjustedPositionFactor += promoTileAdjustment
      }

      if (
        inlineTickerMessagesLocation !== undefined &&
        currentIndex ===
          inlineTickerMessagesLocation - modulesAdjustedPositionFactor
      ) {
        items.push(inlineTickerMessages)
      }

      items.push({ ...product })

      return items
    },
    [],
  )
}

export const calculateComponentWidth = (
  component: string,
  numOfTilesPerRow: number,
) => {
  switch (component) {
    case ProductGridComponent.promoTile:
      if (numOfTilesPerRow === AD_CELL_WIDTH_WIDE) return '100%'
      return AD_CELL_WIDTH / numOfTilesPerRow
    case ProductGridComponent.featureEntryPointBanner:
    case ProductGridComponent.inlineTickerMessages:
      return '100%'
    default:
      return 1 / numOfTilesPerRow
  }
}
